import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const PassageLabelsService = {
    list: async () => axios.get(API_KEEPER + "/passage_label").then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(API_KEEPER + `/passage_label/by_id/${id}`).then(({data}) => data).catch((err) => { throw err }),
    save: async (data) => axios.post(API_KEEPER + "/passage_label", data).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(API_KEEPER + `/passage_label/?id=${id}`).then(({data}) => data).catch((err) => { throw err }),
    isPassageLabelInUse: async (id) => axios.get(API_KEEPER + `/passage_label/isPassageLabelInUse/${id}`).then(({data}) => data).catch((err) => { throw err }),
};

export default PassageLabelsService;